import { DropdownActions, DropdownItem } from "../../commons/DropdownActions";
import { TicketListItem } from "../../../services/webServices/ticket/types";

type Props = {
  ticketList: TicketListItem;
  onActionSuccessed: () => void;
};

export default function TicketListActions({ ticketList, onActionSuccessed }: Props) {

  const actions: DropdownItem[] = [
    {
      key: "answered",
      tone: "success",
      label: "پاسخ داده  شده",
      action: () => {return false},
    },
    {
      key: "waiting",
      tone: "warning",
      label: "در انتظار پاسخ",
      action: () => {return false},
    },
  ];

  return (
    <DropdownActions
      items={actions}
      initialKey={ticketList.status === 1 ? "answered" : "waiting"}
      disabled={true}
    />
  );
};